import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop
 *
 * React Router doesn't reset scroll position on route changes (so navigating
 * from a long Q&A page to /pricing would leave you halfway down the new
 * page). Mount this once inside <BrowserRouter> and every route change
 * starts at the top, matching native browser behaviour.
 *
 * Anchors (#hash) still work: if a path has a hash we skip the reset so
 * scroll-to-anchor links behave normally.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
